import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./AddDocument.module.scss";
import { CloseIcon } from "Assets/icons";
import { Formik } from "formik";
import acceptAppointmentSchema from "./addForm";
import { APPOINTMENT_LOCATION_OPTIONS, APPOINTMENT_TYPE_OPTIONS } from "config/constants";
import { CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { cloneDeep } from "lodash";
import { useUpdateStatusMutation } from "store/services/appointment";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { successMessageToast } from "helpers/common";

const AcceptAppointmentPop = ({ show, setShow, payloadValues }) => {

    const handlePopup = () => setShow(!show);

    // create appointment
    const [createAppointment, { isLoading: createAppointmentLoading }] = useUpdateStatusMutation();

    const handleSubmit = async (values) => {
        try {

            const payload = cloneDeep(values);
            payload.location = payload?.location?.value
            payload.appointment_type = payload?.appointment_type?.value

            const result = await createAppointment({ ...payloadValues, data: payload });
            if (result?.error) return;

            successMessageToast(result?.data?.message);
            handlePopup();
        } catch (err) { console.log("Error creating appointment", err) };
    };

    const initialValues = {
        title: payloadValues?.data?.title || "",
        description: payloadValues?.data?.description || "",
        appointment_reason: payloadValues?.data?.appointment_reason || "",
        additonal_notes: payloadValues?.data?.additonal_notes || "",
        location: APPOINTMENT_LOCATION_OPTIONS.find(x => x.value == payloadValues?.data?.location) || "",
        location_notes: payloadValues?.data?.location_notes || "",
        location_detail: payloadValues?.data?.location_detail || "",
        appointment_type: APPOINTMENT_TYPE_OPTIONS.find(x => x.value == payloadValues?.data?.appointment_type) || "",
        price: payloadValues?.data?.price || 0.00
    };

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="md"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <Button
                        onClick={handlePopup}
                        className="border-0 p-0 position-absolute"
                        variant="transparent"
                        style={{ right: 15, top: 5 }}
                    >
                        <CloseIcon />
                    </Button>
                    <div>
                        <h4 className="m-0 fw-bold themeBlue">Accept Appointment</h4>
                    </div>
                    <Row className="my-2">
                        <Col className="col-12 my-2">
                            <div className="iconWithText position-relative">
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={acceptAppointmentSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {
                                        ({
                                            handleSubmit,
                                            values,
                                            setFieldValue
                                        }) => (
                                            <Form onSubmit={handleSubmit}>
                                                <Row>
                                                    <Col md="12" sm="12" className="mt-2">
                                                        <label className="form-label fw-bold themeBlue d-flex my-2">
                                                            Title
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name={`title`}
                                                            placeholder="Enter Title"
                                                            className={`${styles.formControl} form-control`}
                                                        />
                                                    </Col>
                                                    <Col md="12" sm="12" className="mt-2">
                                                        <label className="form-label fw-bold themeBlue d-flex my-2">
                                                            Appointment Type
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <CommonSelect
                                                            name={"appointment_type"}
                                                            option={APPOINTMENT_TYPE_OPTIONS}
                                                            placeholder={"Select Appointment Type"}
                                                            onChange={(val) => {
                                                                setFieldValue("price", "0")
                                                                setFieldValue("appointment_type", val)

                                                            }}
                                                        />
                                                    </Col>
                                                    {
                                                        values?.appointment_type?.value == "paid" && <Col md="12" sm="12" className="mt-2">
                                                            <label className="form-label fw-bold themeBlue d-flex my-2">
                                                                Price
                                                                {values?.appointment_type?.value == "paid" && <RequiredFieldAstrick />}
                                                            </label>
                                                            <AppInputField
                                                                fieldType="number"
                                                                name={`price`}
                                                                placeholder="Enter Price"
                                                                className={`${styles.formControl} form-control`}
                                                                min={0}
                                                                onKeyDown={(e) => (e.key === "-" || e.key === "e" || e.key === "E") && e.preventDefault()}
                                                            />
                                                        </Col>
                                                    }
                                                    <Col md="12" sm="12" className="mt-2">
                                                        <label className="form-label fw-bold themeBlue d-flex my-2">
                                                            Location
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <CommonSelect
                                                            name={"location"}
                                                            option={APPOINTMENT_LOCATION_OPTIONS}
                                                            placeholder={"Select Location"}
                                                        />
                                                    </Col>
                                                    <Col md="12" sm="12" className="mt-2">
                                                        <label className="form-label fw-bold themeBlue d-flex my-2">
                                                            Description
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name={`description`}
                                                            placeholder="Enter Description"
                                                            fieldType={"textarea"}
                                                            className={`${styles.formControl} form-control`}
                                                            maxLength={500}
                                                            style={{ height: "100px" }}
                                                        />
                                                    </Col>
                                                    <Col md="12" sm="12" className="mt-2">
                                                        <label className="form-label fw-bold themeBlue d-flex my-2">
                                                            Reason
                                                            <RequiredFieldAstrick />
                                                        </label>
                                                        <AppInputField
                                                            name={`appointment_reason`}
                                                            placeholder="Enter Reason"
                                                            fieldType={"textarea"}
                                                            className={`${styles.formControl} form-control`}
                                                            maxLength={500}
                                                            style={{ height: "100px" }}
                                                        />
                                                    </Col>
                                                    <Col md="12" sm="12" className="mt-2">
                                                        <label className="form-label fw-bold themeBlue d-flex my-2">
                                                            Location Notes
                                                        </label>
                                                        <AppInputField
                                                            name={`location_notes`}
                                                            placeholder="Enter Location Notes"
                                                            fieldType={"textarea"}
                                                            className={`${styles.formControl} form-control`}
                                                            maxLength={500}
                                                            style={{ height: "100px" }}
                                                        />
                                                    </Col>
                                                    <Col md="12" sm="12" className="mt-2">
                                                        <label className="form-label fw-bold themeBlue d-flex my-2">
                                                            Location Details
                                                        </label>
                                                        <AppInputField
                                                            name={`location_detail`}
                                                            placeholder="Enter Location Details"
                                                            fieldType={"textarea"}
                                                            className={`${styles.formControl} form-control`}
                                                            maxLength={500}
                                                            style={{ height: "100px" }}
                                                        />
                                                    </Col>
                                                    <Col md="12" sm="12" className="mt-2">
                                                        <label className="form-label fw-bold themeBlue d-flex my-2">
                                                            Additonal Notes
                                                        </label>
                                                        <AppInputField
                                                            name={`additonal_notes`}
                                                            placeholder="Enter Additonal Notes"
                                                            fieldType={"textarea"}
                                                            className={`${styles.formControl} form-control`}
                                                            maxLength={500}
                                                            style={{ height: "100px" }}
                                                        />
                                                    </Col>
                                                    <Col md="12" sm="12" className="mt-4">
                                                        <div className="w-100 d-flex justify-content-center">
                                                            <Button
                                                                type="submit"
                                                                className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                                                                disabled={createAppointmentLoading}
                                                            >
                                                                {createAppointmentLoading ? <LoadingIndicator color="#fff" /> : "Save"}
                                                            </Button>
                                                        </div>

                                                    </Col>
                                                </Row>
                                            </Form>
                                        )}
                                </Formik>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default AcceptAppointmentPop;